<script>
    import LPBrowseView from "../LeftSidePanel/LPBrowseView.svelte";
    import WPNRelatedItems from "../Misc/WPNRelatedItems.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import { itemsForCategory, associatedItemsForEntities, allCategories } from "../../scripts/wpn2Model.js";
    import { addRelatedItem, removeRelatedItem } from "../../scripts/wpn2Edit.js";

    export let selectedItem = null;
    let workItems;
    let assetItems;
    let browseCat = null;
    let browsableData = [];

    $: browsableData = setBrowsableData(browseCat);
    $: workItems = associatedItemsForEntities(['Activity', 'Issue', 'WorkOrder'], $dbData.all, item);
    $: assetItems = associatedItemsForEntities(['FixedAsset', 'Pipe'], $dbData.all, item);

    function setBrowsableData(cat) {
        return itemsForCategory(cat, $dbData)
    }

    function removeItem(event) {
        console.log("Remove: ", event.detail);
        selectedItem = removeRelatedItem(event.detail.item, selectedItem);
    }

    function addItemToRelated(event) {
        console.log("Add: ", event.detail);
        selectedItem = addRelatedItem(event.detail.item, selectedItem);
        browseCat = null;
    }

</script>

{#if browseCat != null}
    <div class="center-browser">
        <LPBrowseView
            searchCat={browseCat}
            {browsableData}
            filteredData={browsableData}
            actionButtons={[]}
            cellButtonTypes={["Add"]}
            on:item-add={addItemToRelated}
            on:close-search-table={() => browseCat = null}
        />
    </div>
{:else}
    <div class="edit-container">
        <div class="edit-section-title">Related Work & Assets</div>
        {#if workItems.length == 0}
            <p class="edit-related-statement">
                {"No work is associated with " +  selectedItem.name ?? selectedItem.wpn2_type + "."}
            </p>
        {/if}
        <WPNRelatedItems
            item={selectedItem}
            category="work"
            cellButtonTypes={["Remove"]}
            on:item-remove={removeItem}
        />
        <div class="add-button-view">
            <button class="edit-add-button" on:click={() => browseCat = allCategories().find((x) => x.name == 'work')}>
                Add Work
            </button>
        </div>
        {#if assetItems.length == 0}
            <p class="edit-related-statement">
                {"No assets are associated with " + selectedItem.name ?? selectedItem.wpn2_type + "."}
            </p>
        {/if}
        <WPNRelatedItems
            item={selectedItem}
            category="assets"
            cellButtonTypes={["Remove"]}
            on:item-remove={removeItem}
        />
        <div class="add-button-view">
            <button class="edit-add-button" on:click={() => browseCat = allCategories().find((x) => x.name == 'assets')}>
                Add Assets
            </button>
        </div>
    </div>
{/if}

<style>
    .edit-related-statement {
        padding-left: 1rem;
    }
    .center-browser {
        position: relative;
        margin: auto;
        max-width: max-content;
        min-width: 440px;
        max-height: 440px;
        font-family: "Source Sans Pro", sans-serif;
        font-size: 0.8rem;
        line-height: 1;
        background-color: #fff;
        border: solid 3px #cfc5c5;
        overflow: scroll;
    }
</style>
